// extracted by mini-css-extract-plugin
var _1 = "BookPageImageRange__fillerHalf--MbkGP";
var _2 = "BookPageImageRange__gradeIcon--UWOgf";
var _3 = "BookPageImageRange__lessonLinksOuter--P5Uf8";
var _4 = "BookPageImageRange__linksContainer--vJaXA";
var _5 = "BookPageImageRange__main--TVlwx";
var _6 = "BookPageImageRange__stopSign--VVnPD";
var _7 = "BookPageImageRange__stopSignText--bS7f1 CoreGeneral__robotoSlab--X8lgW";
export { _1 as "fillerHalf", _2 as "gradeIcon", _3 as "lessonLinksOuter", _4 as "linksContainer", _5 as "main", _6 as "stopSign", _7 as "stopSignText" }
